import { css } from "styled-components";

/** Shared chip shell metrics for ProfileTag and EmptyTeammatesPlaceholder. */
export const profileTagShellStyles = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 8px 16px;
  border-radius: 8px;
`;
